import React from 'react';
import { Modal, Button } from "react-bootstrap";
import "./styles.css";

const ConfirmationModal = ({
    show,
    title = "Confirmation",
    message,
    onConfirm,
    onCancel,
    confirmText = "Yes",
    cancelText = "No"
}) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {cancelText}
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal; 